import React from "react";
import ReactModal from "react-modal";

import BAAUploader from "./BAAUploader";
import { WebTrackerResolution } from "../types";

export type BAAUploadModalProps = {
  onClose: () => void;
  siteDomain: string;
  trackerDomain: string;
  trackerName: string;
  resolution: WebTrackerResolution;
  setIsResolutionLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

function BAAUploadModal({
  onClose,
  siteDomain,
  trackerDomain,
  trackerName,
  resolution,
  setIsResolutionLoading,
}: BAAUploadModalProps) {
  const customStyles = {
    content: {
      zIndex: 10050,
      minHeight: `20vh`,
      maxHeight: 700,
      top: "auto",
      bottom: "auto",
      right: "auto",
      left: "auto",
      position: "static" as "static",
      display: "flex",
      padding: 0,
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, .5)",
      zIndex: 10000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };

  return (
    <ReactModal
      isOpen={true}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Upload Web Tracker BAA"
    >
      <BAAUploader
        onClose={onClose}
        siteDomain={siteDomain}
        trackerDomain={trackerDomain}
        trackerName={trackerName}
        resolution={resolution}
        setIsResolutionLoading={setIsResolutionLoading}
      />
    </ReactModal>
  );
}

export default BAAUploadModal;
